import type React from "react";
import { ReactComponent as Svg } from "./assets/shield-lock.svg";
import * as styles from "./Icon.module.scss";

type ShieldLockProps = React.SVGProps<SVGSVGElement>;

export const ShieldLock = ({ className, ...props }: ShieldLockProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
